import React from "react";
import { ToastContainer, ToastContainerProps } from "react-toastify";

const Toast: React.FunctionComponent<ToastContainerProps> = (props) => (
  <ToastContainer
    position="top-right"
    closeButton={false}
    closeOnClick={false}
    enableMultiContainer
    autoClose={3000}
    {...props}
  />
);
export default Toast;
